import {IArticleModel} from '@src/@interfaces/models/Article/IArticleModel';

export function resolveArticleSlug(article: IArticleModel): string {
    return `${article.id}--${article.url}`;
}
